import React, { Component } from 'react';
import {
    withRouter
} from 'react-router-dom';
import {

} from '@shopify/polaris-icons';
import './index.css';
// 翻译
import CompetitorKeywords from '../CompetitorKeywords/indexClass';
import KeywordsLibrary from '../KeywordsLibrary/indexClass';

import { reqSaveSwitchState } from '../../../api'
import SwitchAll from '../../../utils/switchState';
import { cloneDeep } from 'lodash';
import { connect } from 'react-redux'
import { setSaveSwitchData } from '../../../redux/actions/getAppPublicData';
import SkeltonLoading from '../../../components/SkeltonLoading';
class KeywordsResearch extends Component {
    state = {
        userServices: this.props.userServices,
        isShowIssueBanner: true,
        isShowCKBanner: true,
        loadingPageCK: true,
        loadingPageKL: true,

        showToast: false,
        showToastText: '',
        showToastIserror: false,
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.userServices !== this.props.userServices) {
            this.setState({
                userServices: nextProps.userServices,
            })
        }

        return true;
    }

    //进入页面调用接口
    componentDidMount() {
        this.setSwitchState();
    }

    // 设置状态
    setSwitchState = () => {
        let switchData = this.props.public.publicInit.head_data?.switch_data;
        this.setState({
            isShowCKBanner: typeof switchData === 'boolean' ? true : !Boolean(switchData?.keywords_issue),
        })
    }
    
    showModal = () => {
        this.props.show();
    }

      // 关闭banner
    closeBannerObj = (e) => {
        this.setState({
            isShowCKBanner: false,
        }, () => {
            this.requestStateSet(SwitchAll['kw_issue']);
        })
    }

    // 发送请求
    requestStateSet = async (type) => {
        const params = {
            name: `${type}`,
            st: 0,
            exp: 0,
            type: `param`
        }
        const res = await reqSaveSwitchState(params);
        if (res.ack === 1) {
            let data = cloneDeep(this.props.public.publicInit.head_data?.switch_data)
            if (typeof data === 'boolean') {
                data = [];
            }
            data[`${type}`] = { "at": Math.floor(new Date().getTime() / 1000), "st": 0, "exp": 0 };
            this.props.setSwitchData(data);
        } else {
            this.props.toggleToast('Try again later', true)
        }
    }

    // 设置loading
    setLoadingPageCK = () => {
        this.setState({
            loadingPageCK: false,
        })
    }
    setLoadingPageKL = () => {
        this.setState({
            loadingPageKL: false,
        })
    }

    render() {
        const {
            userServices,
            isShowCKBanner,
            loadingPageCK,
            loadingPageKL,

        } = this.state;

        // 最终页面
        const loadingPageMain = loadingPageCK || loadingPageKL ? <SkeltonLoading /> : null;
        const pageContent = <div className='KeywordsResearch' style={{ display: loadingPageCK || loadingPageKL ? 'none' : 'block' }}>
            <title>SEOAnt - Competitor Keywords Research</title>

            <CompetitorKeywords setLoadingPageCK={this.setLoadingPageCK} userServices={userServices} show={this.showModal} isShowCKBanner={isShowCKBanner} closeBannerObj={this.closeBannerObj} />
            <KeywordsLibrary setLoadingPageKL={this.setLoadingPageKL} userServices={userServices} show={this.showModal} />
        </div>

        return <div>
            {loadingPageMain}
            {pageContent}
        </div>;
    }
}

const mapStateToProps = state => {
    return state
}

const mapDispatchToProps = dispatch => ({
    // 设置自定义缓存
    setSwitchData(data) {
        dispatch(setSaveSwitchData(data))
    }
})

KeywordsResearch = connect(
    mapStateToProps,
    mapDispatchToProps
)(KeywordsResearch);

export default withRouter(KeywordsResearch);